import React, {useState} from "react";
import Modal from "../../../ui-components/Modal";
import {FormattedMessage} from "react-intl";
import {QuotationProductEditQuantityModalProps} from "../types";
import Button from "../../../ui-components/Button";
import {formatNumber} from "../quotation-draft/lib/format";
import Input from "../../../ui-components/Input";
import {round} from "lodash";

export const EditProductQuantityModal = ({
  originalQuantity,
  currentQuantity,
  minQty,
  um,
  onConfirm,
  onReset,
  onExit,
}: QuotationProductEditQuantityModalProps) => {

  // data
  const hasPackages = !!minQty;
  const packagesInitialValue = hasPackages ? Math.ceil(currentQuantity / minQty) : null;

  // state
  const [packages, setPackages] = useState<number | null>(packagesInitialValue);
  const [newQuantity, setNewQuantity] = useState<number>(currentQuantity);

  // utilities
  const newQuantityValue = hasPackages ? minQty * packages! : newQuantity;
  const showResetBtn = !!onReset;/*currentQuantity !== originalQuantity;*/
  const disableConfirmBtn = hasPackages ? !packages : !newQuantity;

  return (
    // @ts-ignore
    <Modal
      onExit={onExit}
      // @ts-ignore
      opened={true}
    >
      <h1 className="text-center text-xl font-extrabold mt-3">
        <FormattedMessage id="edit_quantity" />
      </h1>
      <div className="flex flex-col gap-4 py-6">
        <div className="flex flex-col gap-2">
          <p className="font-semibold">
            <FormattedMessage id="current_quantity" />
          </p>
          <p>{formatNumber(currentQuantity)} {um?.toUpperCase()}</p>
        </div>
        <div className="flex flex-col gap-2">
          <p className="font-semibold">
            <FormattedMessage id="new_quantity" />
          </p>
          <div className="flex gap-3 items-center justify-start">
            {
              hasPackages
                ? <>
                  {/* @ts-ignore */}
                  <Input
                    value={round(packages!, 2)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPackages(parseInt(e.target.value))}
                    step="1"
                    showErrorDialog={false}
                  />
                  <span>&times;</span>
                  <span className="whitespace-nowrap">
                    {formatNumber(minQty)} {um?.toUpperCase()}
                  </span>
                  <span>=</span>
                  <span className="whitespace-nowrap">
                    {formatNumber(newQuantityValue)} {um?.toUpperCase()}
                  </span>
                </>
                : <>
                  {/* @ts-ignore */}
                  <Input
                    type="number"
                    value={round(newQuantity, 2)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewQuantity(e.target.value as unknown as number)}
                    step=".01"
                    showErrorDialog={false}
                  />
                  <span>{um?.toUpperCase()}</span>
                </>
            }
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col sm:flex-row gap-x-4 gap-y-2">
        {showResetBtn && (
          <div className="sm:flex-1">
            <Button
              full
              styleType="redWhite"
              onClick={() => {
                onReset();
                onExit();
              }}
            >
              <FormattedMessage id="reset" />
            </Button>
          </div>
        )}
        <div className="sm:flex-1">
          <Button
            full
            onClick={() => {
              onConfirm(newQuantityValue);
              onExit();
            }}
            disabled={disableConfirmBtn}
          >
            <FormattedMessage id="confirm" />
          </Button>
        </div>
      </div>
    </Modal>
  )
}